import Highcharts from 'highcharts'
import React, { useEffect } from 'react'
import score from '../../assets/score.svg'
import Card from '../Card/Card'
import './OverAllScore.css'

export const subjectName = (subject) => {
    let subName
    if (subject.toLowerCase() == 'mathematics') subName = 'Math'
    if (subject.toLowerCase() == 'chemistry') subName = 'Chem'
    if (subject.toLowerCase() == 'physics') subName = 'Phy'
    if (subject.toLowerCase() == 'biology') subName = 'Bio'
    if (subject.toLowerCase() == 'geography') subName = 'Geo'
    if (subject.toLowerCase() == 'history') subName = 'History'
    if (subject.toLowerCase() == 'mental ability') subName = 'Mat'
    if (subject.toLowerCase() == 'political science') subName = 'Pt. Sc'
    if (subject.toLowerCase() == 'zoology') subName = 'Zoology'
    if (subject.toLowerCase() == 'economics') subName = 'Eco'
    if (subject.toLowerCase() == 'botany') subName = 'Bot'
    if (subject.toLowerCase() == 'science') subName = 'Sci'
    return subName
}
export const colorName = (subject) => {
    let colName
    if (subject.toLowerCase() == 'mathematics') colName = '#24c5c9'
    if (subject.toLowerCase() == 'chemistry') colName = '#fca945'
    if (subject.toLowerCase() == 'physics') colName = '#ed5252'
    if (subject.toLowerCase() == 'biology') colName = '#69a8e2'
    if (subject.toLowerCase() == 'geography') colName = '#6c81f6'
    if (subject.toLowerCase() == 'history') colName = '#fe7b4b'
    if (subject.toLowerCase() == 'mental ability') colName = '#449697'
    if (subject.toLowerCase() == 'political science') colName = '#24b299'
    if (subject.toLowerCase() == 'zoology') colName = '#222e4e'
    if (subject.toLowerCase() == 'economics') colName = '#9952b7'
    if (subject.toLowerCase() == 'botany') colName = '#4c9400'
    if (subject.toLowerCase() == 'science') colName = '#fca443'
    return colName
}
const OverAllScore = (props) => {
    let sections = []
    let colors = []
    useEffect(() => {
        props.data?.analytics?.sections?.map((item) => {
            let col = colorName(item)
            sections.push(
                "<b style='color: " + col + "'>" + subjectName(item) + '</b>',
            )
            colors.push(col)
        })
        Highcharts.chart('container', {
            chart: {
                showAxes: true,
                height: props.width - 40,
                width: props.width,
            },
            colors: colors,
            title: {
                text: '',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: sections,
                title: {
                    text: null,
                },
            },
            yAxis: {
                lineColor: '#999',
                lineWidth: 0.5,
                min: 0,
                max: props.data.analytics.overallTestScore,
                title: {
                    text: '',
                    align: 'high',
                },
                labels: {
                    overflow: 'justify',
                },
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        color: 'black',
                        formatter: function (val) {
                            if (this.y >= 90) {
                                val.y = -15
                            }
                            return this.y
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            series: [
                {
                    type: 'bar',
                    colorByPoint: true,
                    data: props.data.analytics.sectionWiseMarks,
                    showInLegend: false,
                    pointWidth: 13,
                },
            ],
        })
    }, [props.data?.analytics?.sections])

    return (
        <div className="overallscore">
            <Card>
                <div className="card-header">
                    <div className="card-overall-score-text">
                        <img src={score} /> &nbsp;&nbsp;Overall Score
                    </div>
                    <div className="card-overall-score">
                        <span className="card-overall-score-marks">
                            {props.data.analytics.overallScore}
                        </span>
                        /{' '}
                        <span className="card-overall-score-max-marks">
                            {props.data.analytics.overallTestScore}
                        </span>
                    </div>
                </div>
                <div id="container"></div>
            </Card>
        </div>
    )
}

export default OverAllScore
